import { Container, Heading, Section } from 'react-bulma-components';

import React from 'react';
import networkError from "assets/images/gclef.png";

const ServerError = () => {
return(
  <div>
    <Section>
        <Container>
          <p className="bd-notification is-success">
            <Heading size={5} renderAs="p">Unexpected error</Heading>
            <Heading subtitle renderAs="p">Oops, an unexpected error occured. Sorry! :-(</Heading>
            <img
              src={networkError}
              style={{
                height: "200px",
                display: "block",
                margin: "auto",
                position: "relative",
                WebkitTransform: "scaleX(-1)",
                transform: "scaleX(-1)",
            }}
            />
          </p>
        </Container>
      </Section>
    </div>
);
}
export default ServerError;